import {
  FilterMode,
  SignedEditionBlockchainCert_OrderBy,
  SignedEditionBlockchainCert,
  SortOrder,
  SignedEditionBlockchainCert_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const signedEditionBlockchainCertService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.signedEditionBlockchainCertOne({ id });
    return result.signedEditionBlockchainCertOne as SignedEditionBlockchainCert;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: SignedEditionBlockchainCert_OrderBy[] | null = null,
    filter: SignedEditionBlockchainCert_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: SignedEditionBlockchainCert_Filter | undefined;
    if (searchValue !== "") {
      where = { name: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.signedEditionBlockchainCertListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ name: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.signedEditionBlockchainCertListWithOffset
    ) as SignedEditionBlockchainCert[];
    return { list, orderBy };
  },
};
